import { render, staticRenderFns } from "./EditV2.vue?vue&type=template&id=02341732"
import script from "./EditV2.vue?vue&type=script&lang=js"
export * from "./EditV2.vue?vue&type=script&lang=js"
import style0 from "./EditV2.vue?vue&type=style&index=0&id=02341732&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports